const SpeakerData27 = [
  {
    name: "Damon West",
    role: "Best-Selling Author and Speaker",
    description: `Damon West, M.S. Criminal Justice, is an internationally known keynote speaker, bestselling author, and former Dallas crime boss who served seven years of a life sentence for organized crime. Once a Division 1 starting quarterback, a career-ending injury led him to severe drug addiction. After working in Congress and training as a UBS stockbroker, methamphetamine derailed his life. While incarcerated, a profound spiritual awakening changed him. Like a coffee bean under pressure, he learned to transform his environment. Emerging from prison with a program of recovery and renewed faith, Damon is now on parole until 2073. His powerful story is a masterclass in hope, redemption, grit, and the resilience of the human spirit.`,
    isKeynote: true,
    ytData: [
      {
        img: "https://drive.google.com/open?id=1R1kBfDqnGViUZmr7P_SlUcoEqriKsDKL&usp=drive_fs",
        id: "",
        title: "It's Never Too Late to Rewrite Your Story",
        date: "",
        time: "",
        description: `Hear about how a former college quarterback, sentenced to life in prison, transformed his life. Damon West learned how to change the environment around him and emerged - after more than seven years in prison - a changed man, sparked by a life-changing conversation inside prison.`,
      },
    ],
  },

  {
    name: "Steven Rick",
    role: "Chief Economist, TruStage",
    description: `Steve Rick is the chief economist for TruStage. His forecasts are the starting point for the strategic planning process and help create a clear understanding of the underlying trends and links between the general economy and the financial services industry. Rick was previously the senior economist for CUNA’s Economics & Statistics Department for 22 years. In addition to his work at TruStage, he serves on the Board of Directors of the University of Wisconsin Credit Union (UWCU), a $6 billion financial institution. Rick also held a senior lecturer position with the Economics Department at the University of Wisconsin–Madison for 26 years where he taught banking and macroeconomics courses.`,
    isKeynote: true,
    ytData: [
      {
        img: "",
        id: "",
        title: "U.S. Economic Outlook & Its Impact on Financial Institutions",
        date: "",
        time: "",
        description:
          "Steve Rick will discuss how the global economy, the overall financial sector and the labor market will affect the U.S. economy, U.S. interest rates, and ultimately financial institutions' balance sheets and earnings performances. Rick will also analyze and establish standards against which your financial institution’s own performance can be measured. He will also identify trends of savings and loan activity, and weigh the influence of future economic events on growth patterns out into 2028.",
        takeaways: [
          "Learn how the Federal Reserve sets short-term interest rates.",
          "Review the current and forecasted state of the U.S. economy.",
          "Understand the economic factors impacting financial institution operations and performance.",
        ],
      },
    ],
  },

  {
    name: "Christie Summervill",
    role: "Chief Executive Officer, BalancedComp",
    description: `With over 25 years of experience, Christie Summervill, CEO and Principal of BalancedComp, has helped organizations design competitive salary structures, incentive plans, performance management systems, and total rewards strategies that drive talent retention, regulatory compliance, and business performance. A sought-after speaker and conference host (FINCOMP), she delivers practical, data-driven insights on emerging compensation trends, pay transparency, and aligning rewards with strategic goals. Her HRCI/SHRM-accredited webinars and client-focused sessions are known for translating`,
    ytData: [
      {
        img: "",
        id: "",
        title:
          "From Benchmark to Business Impact: Essential Insights and Salary Trends for Compensation Leaders",
        date: "",
        time: "",
        description: `Christie Summervill, CEO and Principal of BalancedComp, LLC, brings over 25 years of compensation consulting experience to help financial institutions design effective salary structures, incentives, performance management programs and CEO compensation plans. In this session, she will explore the latest shifts in pay strategies that are quietly revolutionizing the banking world. We'll break down how to stay competitive without breaking the budget (or your CFO's heart). Expect practical insights on aligning pay with performance, keeping regulators happy, and yes, finally answering that eternal question: "Are we paying enough… or just enough to lose them slowly?" You'll leave armed with data, strategies, and just enough sass to defend your next comp plan with a straight face and a strong case.`,
      },
    ],
  },

  {
    name: "Philippe Asselin",
    role: "Chief Consultant, BalancedComp",
    description: `Philippe Asselin brings together operational leadership, financial institution expertise, and compensation strategy to help financial institutions build high-performing organizations. Having worked with hundreds of financial institutions nationwide, Philippe is known for helping leadership teams simplify complex compensation decisions, align incentives with performance, and create systems that scale. His background spans executive leadership in hospitality, banking, and FinTech—giving him a practical understanding of how compensation impacts culture, accountability, and organizational growth. Today, at BalancedComp, Philippe partners with FI's to build smarter, more effective programs that support both people and performance.`,
    ytData: [
      {
        img: "",
        id: "",
        title: "The Truth Problem in Compensation Philosophy",
        date: "Tuesday, June 9",
        time: "11:15 am - 11:45 am",
        description: `This presentation explores why compensation philosophies in banks and credit unions often fail to drive engagement, trust, and long-term sustainability when they lose alignment with objective market data, measurable performance standards, organizational culture, and financial realities. Attendees will learn how transparency, communication, adaptability, operational efficiency, and continuously evolving variable pay strategies can strengthen total rewards programs while supporting retention, performance, and institutional sustainability. Designed for executive and HR leaders, this session provides practical frameworks and strategic insights for building compensation philosophies that remain credible, competitive, and sustainable in rapidly changing labor and economic environments.`,
      },
    ],
  },

  {
    name: "Crystal Hughes",
    role: "Compensation & Performance Consultant, BalancedComp",
    description: `Crystal Hughes is a Compensation Consultant at BalancedComp, a specialized HR consulting firm dedicated to serving banks and credit unions nationwide. With over five years of experience in strategic business planning for small businesses, Crystal brings a passionate, client-focused approach to compensation consulting. She excels at interpreting market data and helping financial institutions make informed, strategic HR decisions that align compensation practices with organizational goals, employee advocacy, and long-term success. In addition to her consulting work, Crystal is an active contributor to industry insights through her writing. Her blog articles include "Why Hire a Compensation Consultant?" and "Fixing Title Confusion: A Case for Job."`,
    ytData: [
      {
        img: "",
        id: "",
        title: "Getting Supervisors to Deliver: An HR Leaders Panel",
        date: "",
        time: "",
        description: `This panel brings together experienced HR executives to openly share their real-world struggles and hard-earned successes in getting supervisors and managers to deliver effective, meaningful performance reviews. Rather than focusing on templates or theory, the discussion dives into the practical challenges—resistance, lack of skills, time constraints, and discomfort—and the proven strategies these leaders used to drive real behavior change across their organizations. Attendees will hear candid stories, actionable tactics, and interactive Q&A, making this a highly practical session designed for HR professionals who want to move beyond frustration to measurable improvement in performance management.`,
      },
    ],
  },

  {
    name: "Sanjyot Mohile",
    role: "SVP Human Resources, Alloya",
    description: `Sanjyot Mohile leads Alloya's human resources strategy, overseeing culture, engagement, recruitment, compensation, benefits, and employee relations. With over 25 years at Alloya, she has championed employee engagement initiatives and spearheaded the organization's remote work program. Sanjyot holds a BS from Eastern Michigan University, an MS in Human Resources from Central Michigan University, and a doctorate in Human Resource Development from the University of Illinois. Her doctoral research focused on sustaining engagement in remote environments - a topic she will share insights on during this presentation.`,
    ytData: [
      {
        img: "https://drive.google.com/open?id=1hbUYDLe-ww_Wyprh0z7Od3R2Ti9uwxHH&usp=drive_fs",
        id: "",
        title: "Remote Done Right: Our Blueprint for Success",
        date: "",
        time: "",
        description: `As organizations navigate the evolving world of work, many are leaning toward return-to-office strategies. We've taken a different path - and have seen the benefits firsthand. Remote work has shifted from a temporary fix to a true competitive advantage. In this session, discover how our approach has delivered measurable benefits to the company and employees - reducing costs, expanding talent pools, and driving engagement. Learn how we leverage flexibility and our culture to launch large-scale projects, maintain exceptional customer service scores, increase the bottom line, reduce costs, and achieve some of the highest Gallup engagement results in our history. If you've ever wondered whether remote work can deliver measurable business impact and desired benefits, this session will show you how. We will demonstrate how by using a real-life case study example.`,
      },
    ],
  },

  {
    name: "Deborah Reid",
    role: "Sr. Executive Consultant, BalancedComp",
    description: `To see Deborah Reid truly in her element, you've got to witness her on-site with new clients implementing the BalancedComp product, training, and educating. She has more than 30 years experience as an SHRM-certified HR professional. That expertise, coupled with the prowess of the applications, makes Deborah a trusted advisor to hundreds of banks and credit unions across the US.<br><br>She has an honest approach to HR management that makes her an empathetic and stalwart partner committed to ensuring her clients earn the greatest value through her counsel. When she's not in the room with clients, she's readily available to troubleshoot a performance review or position grade, or work through a compensation concern.<br><br>Deborah is a devoted contributor to the Kansas Humane Society and St. Jude charities. Her heart is otherwise dedicated to a large family of three adult children, and twin labradors!`,
    ytData: [
      {
        img: "",
        id: "",
        title: "",
        date: "",
        time: "",
        description: "",
      },
    ],
  },

  {
    name: "Coming Soon!",
    role: "",
    description: `Speaker details coming soon!.`,
    ytData: [],
  },

  {
    name: "Coming Soon!",
    role: "",
    description: `Speaker details coming soon!.`,
    ytData: [],
  },

  {
    name: "Coming Soon!",
    role: "",
    description: `Speaker details coming soon!.`,
    ytData: [],
  },

  {
    name: "Coming Soon!",
    role: "",
    description: `Speaker details coming soon!.`,
    ytData: [],
  },
];

export default SpeakerData27;
